import { CircleCheckBig } from "lucide-react";

import { cn } from "@/lib/cn";

interface ProgressBadgeProps {
  done: number;
  total: number;
  className?: string;
}

/**
 * "N / M" on a project row.
 *
 * §1 — there is no green in the Telegram palette and none may be introduced,
 * so a completed project is NOT tinted. §7 gives the sanctioned alternative:
 * "done" reads through `circle-check-big` in `--hint` plus a dim, never
 * through a colour of its own. The accent stays reserved for what is live now.
 */
export function ProgressBadge({ done, total, className }: ProgressBadgeProps) {
  const empty = total === 0;
  const complete = !empty && done >= total;
  return (
    <span
      aria-label={`Прогресс: ${done} из ${total}`}
      className={cn(
        "inline-flex h-[22px] shrink-0 items-center gap-1 rounded-badge px-2 text-chip font-medium tabular-nums",
        complete ? "bg-sep text-hint" : empty ? "bg-sep text-hint" : "bg-sbg text-text",
        className,
      )}
    >
      {complete && <CircleCheckBig className="h-3 w-3 shrink-0" aria-hidden="true" />}
      {done}/{total}
    </span>
  );
}
